export const EX_ADD = "EX_ADD"
export const EX_EDIT = "EX_EDIT"
export const EX_REMOVE = "EX_REMOVE"
export const EX_SET = "EX_SET"
export const EX_STATUS = "EX_STATUS"
